import './pages.css';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { actionTypes } from './../../store';
import InputMask from 'react-input-mask';
import axios from "axios";
import { validationCpf, validationEmail } from "../../validations.js";
import { differenceInYears, parseISO } from 'date-fns';
import parse from 'html-react-parser';


export default function TCLE({changePage}){
    const data = useSelector((state) => state.data?.TCLE);
    const dispatch = useDispatch();
    const states = useSelector((state) => state.states);
    const [showFullText, setShowFullText] = useState(false);
    const baseData = {
                      "paciente_resposavel_1": "",
                      "paciente_resposavel_2": "",
                      "grau_de_Parentesco": "",
                      "nome_completo": "",
                      "documento_tipo": "",
                      "cidade": "",
                      "paciente_resposavel2": "",
                      "grau_de_Parentesco2": "",
                      "nome_completo2": "",
                      "documento_tipo2": "",
                      "cidade2": "",
                    }

    const [currentData, setCurrentData] = useState({...baseData,...data})

    const textShort = `1. O teste genético será realizado para avaliação diagnóstica e/ou preventiva de condições de origem
        genética. Esse teste complementa outras investigações clínicas e laboratoriais pertinentes.<br>
        2. Os testes genéticos podem ser realizados através da coleta de amostras de sangue periférico...`
    const texts = [`O teste genético será realizado para avaliação diagnóstica e/ou preventiva de condições de origem
        genética. Esse teste complementa outras investigações clínicas e laboratoriais pertinentes.`,
        `Os testes genéticos podem ser realizados através da coleta de amostras de sangue periférico e/ou
        saliva, ambos os procedimentos apresentam baixo risco à saúde do paciente. A coleta de sangue é
        um procedimento não invasivo, porém pode ocasionar desconforto momentâneo, edema e hematoma
        no local. Para coleta de saliva ou swab bucal é recomendado jejum de 2h antes do procedimento. A
        não realização do preparo pode interferir diretamente na qualidade da realização do teste. Caso a
        recuperação de material genético seja insuficiente para realização do exame, nova coleta poderá ser
        solicitada.`,
        `Os resultados dos testes genéticos devem ser interpretados à luz do quadro clínico, e conjuntamente
        com outros testes laboratoriais e de imagem, caso apropriados. Esses testes podem colaborar com o
        diagnóstico da condição clínica, ou detectar riscos futuros de desenvolvimento de doenças. A análise
        genética pode auxiliar no diagnóstico clínico, prognóstico e tratamento, a depender da clínica.`,
        `Como outros testes diagnósticos, os testes genéticos apresentam limitações técnicas específicas,
        relacionadas à metodologia e determinadas condições clínicas, descritas no laudo do exame.
        Adicionalmente, os pacientes podem portar alterações indetectáveis pela técnica solicitada. Caso o
        paciente tenha realizado transplante de medula óssea há menos de seis meses é importante mencionar
        o fato ao médico solicitante, que verificará a possibilidade de prosseguimento do exame, uma vez que
        material genético do doador poderá estar presente na amostra e ser analisada, podendo interferir na
        interpretação do resultado do próprio paciente.`,
        `A amostra coletada ou entregue em um dos laboratórios do Hospital Israelita Albert Einstein será
        utilizada para realização do exame conforme metodologia solicitada em pedido médico apresentado
        pelo paciente ou seu responsável.`,
        `Uma amostra dos pais biológicos ou outros familiares, poderá ser solicitada para complementar a
        interpretação dos dados genéticos do paciente, quando necessário.`,
        `O laudo é liberado de acordo com o conhecimento científico atual. A interpretação dos achados
        genéticos e, portanto, dos resultados, podem mudar no futuro, com o avanço do conhecimento médico
        ou melhoria dos meios de análise de dados. Além de informações pertinentes ao quadro clínico atual,
        achados adicionais e/ou de significado clínico não conhecido, podem ser relatados no laudo. Como a
        análise dos testes possui limitações, é possível que alguns resultados sejam inconclusivos, apesar da
        execução adequada.`,
        `Há implicações psicológicas, sociais, médicas, éticas e legais envolvidas com o resultado deste
        teste. O paciente ou seu responsável legal devem estar cientes destas implicações, como estresse
        familiar, ansiedade pela liberação do resultado e reações emocionais diversas mediante o diagnóstico
        ou prognóstico.`,
        `Na hipótese de Estudo Familiar, o vínculo biológico dos membros da família envolvidos no estudo
        deverá ser declarado pelo Paciente e/ou Responsáveis Legais, antes da realização do exame, a fim de
        garantir a precisão dos resultados. É da responsabilidade do Paciente e/ou dos Responsáveis Legais,
        o fornecimento das informações. O resultado desse exame, ao ser comparado com os resultados dos
        testes de outros familiares, pode revelar vínculos de parentesco diferentes do declarado. O Hospital
        Israelita Albert Einstein trata o resultado deste exame seguindo o devido sigilo legal.`,
        `O Hospital Israelita Albert Einstein possui processo interno definido para guarda de amostras
        biológicas, de material genético extraído (DNA e RNA) e de dados brutos dos exames.`,
        `Em caso de solicitação de acréscimo de exames, será verificada a disponibilidade de material
        arquivado no banco de amostras da instituição, que poderá ser consultado. A guarda das amostras
        acontece quando há material biológico (sangue, saliva, DNA ou RNA) remanescente após a liberação
        do resultado do exame, evitando assim, uma nova coleta, se amostra disponível.`];

    const [items, setItems] = useState([
        {id:'paciente_resposavel', text: '', type:"radio",class:"col-xs-12  col-lg-6",
            options:[{ id: 'Paciente', name: 'Paciente' },{ id: 'Responsável Legal 1', name: 'Responsável Legal 1' }]},
        {id:'grau_de_Parentesco', text: '', type:"input", placeholder: "Grau de Parentesco", class:"col-xs-12 col-lg-4",
            show:{key:"paciente_resposavel",value:"Responsável Legal 1"}},
        {id:'nome_completo', text: 'Nome completo', type:"input", class:"col-xs-12 col-lg-8"},
        {id:'documento_tipo', text: 'Documento/ Tipo Nº', type:"input", class:"col-xs-12 col-lg-4"},
        {id:'email_assinante', text: 'Email', type:"input", class:"col-xs-12 col-lg-6"},
        {id:'cidade', text: 'Cidade', type:"input", class:"col-xs-12 col-lg-6"},
        {id:'',text:"", type:"hr"},
        {id:'paciente_resposavel2', text: '', name:'Responsável Legal 2 (se aplicável)', type:"checkbox",class:"col-xs-12  col-lg-5"},
        {id:'grau_de_Parentesco2', text: '', type:"input", placeholder: "Grau de Parentesco", class:"col-xs-12 col-lg-4",
            show:{key:"paciente_resposavel2",value:"grau_de_Parentesco2"}},
        {id:'nome_completo2', text: 'Nome completo', type:"input", class:"col-xs-12 col-lg-8"},
        {id:'documento_tipo2', text: 'Documento/ Tipo Nº', type:"input", class:"col-xs-12 col-lg-4"},
        {id:'cidade2', text: 'Cidade', type:"input", class:"col-xs-12 col-lg-6"}
    ]);
    const handleSubmit = (event) => {
        event.preventDefault();
        var eventName = event.nativeEvent.submitter.name;
        if (eventName === "next"){
            var hasError = false;
            var fields = ['email_assinante', 'paciente_resposavel','nome_completo','documento_tipo','cidade']

            if(currentData.paciente_resposavel === 'Responsável Legal 1'){
                fields = [...fields,'grau_de_Parentesco']
            }
            if(currentData.paciente_resposavel2 === true){
                fields = [...fields,'nome_completo2','documento_tipo2','cidade2']
            }
            fields.forEach((f) => {
                if(!(f in currentData) || currentData[f] == "" || currentData[f] == null){
                    setError(f,'Campo Obrigatório')
                    console.log(f)
                    hasError = true;
                }
                else{
                    setError(f, null);
                }
            })
            if (currentData.email_assinante.length > 0){
                var statusEmail = validationEmail(currentData.email_assinante)
                if(!statusEmail){
                    hasError = true;
                    setError('email_assinante', "Email inválido.");
                }
            }
            if(!hasError){
                changePage(eventName)
            }
        }
        else{
                changePage(eventName)
        }
    }
    const setValue = (id, value) => {
        if(id === 'paciente_resposavel2' && value === false){
            var fields = ['nome_completo2','documento_tipo2','cidade2']
            fields.forEach((f) => {
                setError(f,null)
            })
        }
        setError(id, null);
        setCurrentData((actualData) => ({...actualData, [id]:value}));
    }
    function setError(id,value,key="error"){
          setItems((currentItens) => currentItens.map((i) => {
            if(i.id === id ){
                return {...i, [key]: value}
            }
            return i
          }))
    }
    useEffect(()=>{
        if(currentData){
            dispatch({ type: actionTypes.set_data, 'payload': {"TCLE":currentData}});
        }
    },[currentData])
    const getItem = (i, d) => {
        switch (i.type) {
            case "b":
                return (
                 <b id={i.id} className="subtitle">{i.title}</b>
                )
            case "input":
                if (!("show" in i) || d[i.show.key] === i.show.value) {
                    return (
                        <InputMask key={i.id} id={i.id} name={i.id} type="text" placeholder={i.placeholder} title=""
                            value={d && d[i.id]} autoComplete="off" {...i.props} disabled={i.disabled === true}
                            onChange={(event) => setValue(i.id, event.target.value)}  mask={i.mask}
                            className={i.error ? 'border-danger' : ''} />
                    );
                } else {
                    return null;
                }
            case "checkbox":
                return (
                    <label key={i.id} className="label-input label-radio d-flex">
                        <input id={i.id} className="checkInput" type="checkbox" name={i.id}
                            checked={d && d[i.id] } onChange={(event) => setValue(i.id, event.target.checked)} />
                        <b>{parse(i.name)}</b>
                        {(i.input === true && d[i.id] === true) &&
                                    <InputMask key={`input_${i.id}`} id={`input_${i.id}`} name={`input_${i.id}`}
                                        type="text" value={d && d[`${i.tag}age_${i.id}`]} autoComplete="off"
                                        placeholder={i.placeholder}
                                        onChange={(event) => setValue(`age_${i.id}`, event.target.value)}
                                        className={i.error ? 'border-danger' : ''} />
                                }
                    </label>
                );
            case "select":
                return (
                    <select key={i.id} id={i.id} name={i.id} onChange={(event) => setValue(i.id, event.target.value)}>
                        {i.options?.map((o) => (
                            <option key={o.id} value={o.id}>
                                {o.name}
                            </option>
                        ))}
                    </select>
                );
            case "radio":
                return (
                    <div key={i.id} id={i.id} className="d-flex div-radio">
                        {i.options?.map((o) => (
                            <label key={o.id} className="label-input label-radio d-flex">
                                <input id={o.id} className="radioInput" type="radio" name={i.id}
                                    checked={d && d[i.id] === o.id}
                                    onChange={(event) => setValue(i.id, event.target.id)} /><b>{o.name}</b>
                            </label>
                        ))}
                    </div>
                );
            case "hr":
                return (<hr key={i.id} />);
            default:
                return (<div key={i.id} className={`div-input ${i.class}`}></div>);
        }
    };

     return(
        <div className="basePage">
            <h4 className="title">Termo de Consentimento Livre e Esclarecido para Teste Genético</h4>
            <p className="legends">
                {showFullText?
                    <ol>
                        {texts.map((t)=>
                            <li>{t}</li>
                        )}
                        <br/>
                        <a href="#" onClick={()=>setShowFullText(false)}>Ler menos...</a>
                    </ol>:
                    <>
                        {parse(textShort)}
                        <br/>
                        <a href="#"  onClick={()=>setShowFullText(true)}>Ler mais...</a>
                    </>
                }</p>
            <p className="legends">
                Pelo presente Termo de Consentimento Livre e Esclarecido, <b>declaro</b> que recebi todas as
                orientações verbais pertinentes ao procedimento, bem como <b>estou de acordo na íntegra</b>,
                com este termo.
            </p>
            <b className="subtitle">Declaração do Paciente</b>
            <p className="legends">
                Confirmo que recebi explicações, li, compreendi e concordo com os itens acima referidos e que, apesar
                de ter entendido as explicações que me foram prestadas, de terem sido esclarecidas todas as dúvidas
                e estando plenamente satisfeito (a) com as informações recebidas, RESERVO-ME o direito de revogar
                este consentimento até que o procedimento, objeto deste documento, seja iniciado. Fui orientado quanto
                à necessidade de assinar um consentimento informado e compreendi todas as informações contidas neste
                documento.
            </p>
            <form key="form1" id="form1" onSubmit={handleSubmit}>
                <div className="row g-0">
                    { items.map((i)=>{
                        return(<div key={i.id} className={`div-input ${i.class}`}>
                            {i.text != '' && <label htmlFor={i.id} className="label-input">{i.text}</label>}
                            <div className="input-page-1" style={{"width": "100%"}}>
                                { getItem(i,currentData)}
                                {i.error && <span className="error-text">{i.error}</span>}
                            </div>
                        </div>
                    )})}
                </div>
            </form>
        </div>
    );
}